(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
jQuery(document).ready(function ($) {
  var dark_mode = localStorage.getItem("hsp-dark-mode");
  var light_icon = $(".hsp-dark-wrapper").data("light");
  var dark_icon = $(".hsp-dark-wrapper").data("dark");
  var themeurl = hsptheme.themeurl;
  var darklogo = themeurl + "/assets/images/hsp-brand-white.png";
  var lightlogo = themeurl + "/assets/images/hsp-brand-color.png";
  var darkSign = themeurl + "/assets/images/Excellent-Signature-white.png";
  var lightSign = themeurl + "/assets/images/Excellent-Signature.png";
  if ($("body").hasClass("dark-mode")) {
    changeLogo(".fusion-logo-link img", darklogo);
    changeLogo(".excellent-signature .size-full", darkSign);
  }
  if (!$("body").hasClass("logged-in")) {
    if (dark_mode == 1) {
      $("body").addClass("dark-mode");
      $(".hsp-dark-button").addClass("fusion-bar-dark-active").removeClass("fusion-bar-dark-disabled");
      $(".hsp-dark-wrapper img", this).attr("src", dark_icon);
      changeLogo(".fusion-logo-link img", darklogo);
      changeLogo(".excellent-signature .size-full", darkSign);
    }
  }
  if ($(".sticky-button").length > 0) {
    if ($(".hsp-sb-label").attr("data-arrow-color")) {
      $(".hsp-sb-label:before").css("border-right-color", $(".hsp-sb-label").attr("data-arrow-color"));
      addRule(".sticky-button .hsp-sb-label:before", {
        borderRightColor: $(".hsp-sb-label").attr("data-arrow-color")
      });
    }
    var originalBackgroundColor = $('.sticky-button .hsp-sb-icon-wrapper').css('background-color');
    ;
    var originalSvgColor = $('.sticky-button .hsp-sb-icon').css('fill');
    $('.sticky-button').hover(function () {
      $(this).find('.hsp-sb-icon').css('fill', originalBackgroundColor);
      $(this).find('.hsp-sb-icon-wrapper').css('background-color', originalSvgColor);
    }, function () {
      $(this).find('.hsp-sb-icon').css('fill', originalSvgColor);
      $(this).find('.hsp-sb-icon-wrapper').css('background-color', originalBackgroundColor);
    });
    $('.sticky_button_scroll_to_top').click(function () {
      $('html, body').animate({
        scrollTop: 0
      }, 'slow');
    });
  }
  if ($(".hsp-dark-mode").length > 0) {
    $(".hsp-dark-button").click(function (e) {
      e.preventDefault();
      if ($(this).hasClass("fusion-bar-dark-active")) {
        $(this).removeClass("fusion-bar-dark-active").addClass("fusion-bar-dark-disabled");
        $("body").removeClass("dark-mode");
        $(".hsp-dark-wrapper img", this).attr("src", light_icon);
        changeLogo(".fusion-logo-link img", lightlogo);
        changeLogo(".excellent-signature .size-full", lightSign);
        save_hsp_dark_mode_preference(0);
      } else {
        $(this).addClass("fusion-bar-dark-active").removeClass("fusion-bar-dark-disabled");
        $("body").addClass("dark-mode");
        $(".hsp-dark-wrapper img", this).attr("src", dark_icon);
        changeLogo(".fusion-logo-link img", darklogo);
        changeLogo(".excellent-signature .size-full", darkSign);
        save_hsp_dark_mode_preference(1);
      }
    });
  }
  var params = {
    'id': 61510,
    // int, required
    'width': 175,
    // int, optional
    'showReviews': 0,
    // bool, optional
    'reviewsType': 'top',
    // string, optional 
    'reviewsLimit': 1,
    // int, optional
    'socialMedia[]': [],
    // array, optional      
    'position': 'inline',
    // string, optional
    'designFormat': 'portrait',
    // string, optional
    'designType': 'flat',
    // string, optional
    'animatedDirection': 'left',
    // string, optional
    'prefix': '',
    // string, optional
    'addCustomClass': '',
    // string, optional
    'disableJS': '',
    // deaktivieren von JS-Scripten Werte: all|jquery|none
    'validHtml': 'FALSE' // macht das Gütesiegel W3C-Valide, ist aber von der Perfomance etwas schlecht
  };

  //    kundentestsGetSealOfApproval(params);

  function addRule(selector, styles, sheet) {
    styles = function (styles) {
      if (typeof styles === "string") return styles;
      var clone = "";
      for (var p in styles) {
        if (styles.hasOwnProperty(p)) {
          var val = styles[p];
          p = p.replace(/([A-Z])/g, "-$1").toLowerCase(); // convert to dash-case
          clone += p + ":" + (p === "content" ? '"' + val + '"' : val) + "; ";
        }
      }
      return clone;
    }(styles);
    sheet = sheet || document.styleSheets[document.styleSheets.length - 1];
    if (sheet.insertRule) sheet.insertRule(selector + " {" + styles + "}", sheet.cssRules.length);else if (sheet.addRule) sheet.addRule(selector, styles);
    return this;
  }
  function kundentestsGetSealOfApproval(params) {
    var str = '';
    for (var key in params) {
      if (_typeof(params[key]) === 'object') {
        for (var keyInner in params[key]) {
          if (str != '') {
            str += '&';
          } else {
            str += '?';
          }
          str += key + '=' + encodeURIComponent(params[key][keyInner]);
        }
      } else {
        if (str != '') {
          str += '&';
        } else {
          str += '?';
        }
        str += key + '=' + encodeURIComponent(params[key]);
      }
    }
    jQuery.ajax({
      url: 'https://endpoint.kundentests.com/endpoint.php' + str,
      type: 'GET',
      async: true,
      success: function success(response) {
        var jsonResponse = response;
        $(".hsp-kundentests-seal-of-approval").html(jsonResponse.html);
      }
    });
  }
  function save_hsp_dark_mode_preference(value) {
    if ($("body").hasClass("logged-in")) {
      $.ajax({
        url: hsptheme.ajaxurl,
        type: "POST",
        data: {
          action: "save_dark_mode_preference",
          dark_mode: value
        },
        success: function success(response) {
          localStorage.setItem("hsp-dark-mode", value);
        }
      });
    } else {
      localStorage.setItem("hsp-dark-mode", value);
    }
  }
  function changeLogo(selector, logo) {
    $(selector).attr("src", logo);
    $(selector).attr("srcset", logo + " 1x, " + logo + " 2x");
    $(selector).attr("data-retina_logo_url", logo);
  }
});

},{}]},{},[1]);
